import React from 'react';

const SettingsText: React.FC<{ title: string; description?: string }> = ({
  title,
  description = '',
}) => (
  <div className="settings-text-container">
    <p className="settings__title">{title}</p>
    {description && <p className="settings__description">{description}</p>}
  </div>
);

export default SettingsText;
